import { supabase } from "@/integrations/supabase/client";

export interface ClientFailurePayload {
  functionName: string;
  errorMessage: string;
  stage?: string;
  action?: "accept" | "decline";
  requestId?: string;
  vetUserId?: string;
  petOwnerId?: string;
  practiceId?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Best-effort fire-and-forget logger so client-side `functions.invoke`
 * failures (e.g. stale JWT, network blips, 5xx from edge runtime) show up
 * in the admin "Video call failures" monitor alongside server-side errors.
 *
 * Never throws - failure to log must not affect the user-facing flow.
 */
export async function logConsultationCallFailure(payload: ClientFailurePayload): Promise<void> {
  try {
    await (supabase as any)
      .from("consultation_call_failures")
      .insert({
        source: "client_invoke",
        function_name: payload.functionName,
        error_message: payload.errorMessage.slice(0, 2000),
        error_stage: payload.stage ?? null,
        action: payload.action ?? null,
        request_id: payload.requestId ?? null,
        vet_user_id: payload.vetUserId ?? null,
        pet_owner_id: payload.petOwnerId ?? null,
        practice_id: payload.practiceId ?? null,
        metadata: payload.metadata ?? {},
      });
  } catch (err) {
    // Swallow - logging must not break the flow.
    console.warn("[consultation-failure-log] insert failed", err);
  }
}
